import env from './env';
// KNBBridge 类，用于与原生交互
class KNBBridge {
  constructor() {
    // 获取 KNB Promise 实例
    this.KNBP = window.KNB?.getPromiseInstance()
  }

  // 打开页面
  openPage(url, query) {
    // 调用原生 openPage 方法，如果不支持则使用 window.open
    this._handleNativeAction('openPage', { url, query }, () => location.href = url)
  }

  // 跳转页面
  jumpPage(url, query, replace = true) {
    // 调用原生 jumpPage 方法，如果不支持则使用 location.replace 或 location.href
    this._handleNativeAction('jumpPage', { url, query }, () => {
      if (replace) {
        location.replace(url)
      } else {
        location.href = url
      }
    })
  }

  // 关闭页面
  closePage() {
    if (env.isKNB) {
			window.KNB?.closeWebview();
    } else if (env.isMiniprogram) {
      window.wx?.miniProgram?.switchTab({
        url: '/index/pages/mt/mt',
      })
    } else {
      window.history.go(-1);
    }
  }

  // 获取屏幕亮度
  getBrightness() {
    return new Promise((resolve) => {
      if (env.isTitans) {
        this.KNBP.getBrightness()
          .then((res) => {
            resolve(res.value)
          })
          .catch(() => {
            resolve(0.8)
          })
      } else {
        resolve(0.8)
      }
    })
  }

  // 设置屏幕亮度
  setBrightness(value, success = () => {}, fail = () => {}) {
    if (env.isTitans) {
      return this.KNBP.setBrightness({value});
    } else {
      return Promise.resolve('');
    }
    // this._handleNativeAction('setBrightness', { value, success, fail })
  }

  // 订阅页面出现事件
  subAppear(handle, success = () => {}, fail = () => {}) {
    this._handleNativeSubscription('appear', handle, success, fail, () => {
      // 监听 visibilitychange 事件，如果页面变为可见状态则调用 handle
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          handle()
        }
      })
      success()
    })
  }

  // 订阅页面消失事件
  subDisappear(handle, success = () => {}, fail = () => {}) {
    this._handleNativeSubscription('disappear', handle, success, fail)
  }

  // 订阅应用进入前台事件
  subForeground(handle, success = () => {}, fail = () => {}) {
    this._handleNativeSubscription('foreground', handle, success, fail)
  }

  // 订阅应用进入后台事件
  subBackground(handle, success = () => {}, fail = () => {}) {
    this._handleNativeSubscription('background', handle, success, fail)
  }

  // 订阅自定义事件
  subCustomAction(action, handle, success = () => {}, fail = () => {}) {
    this._handleNativeSubscription(action, handle, success, fail)
  }

  // 设置本地存储
  setStorage(key, value, level = 0, success = () => {}, fail = () => {}) {
    this._handleNativeAction(
      'setStorage',
      { key, value, level, success, fail },
      () => {
        // 如果不支持原生存储，则使用 localStorage
        localStorage.setItem(key, value)
        success()
      }
    )
  }

  // 获取本地存储
  getStorage(key, success = () => {}, fail = () => {}) {
    this._handleNativeAction('getStorage', { key, success, fail }, () => {
      // 如果不支持原生存储，则使用 localStorage
      success(localStorage.getItem(key))
    })
  }

  // 取消所有订阅
  unsubscribeAll() {
    ;['appear', 'disappear', 'foreground', 'background'].forEach((action) => {
      this._handleNativeAction('unsubscribe', { action })
    })
  }

  // 初始化 Pike 客户端
  initPikeClient(
    bzId,
    alias,
    extra,
    needContinuousInvoke,
    handle,
    success = () => {},
    fail = () => {}
  ) {
    this._handleNativeAction('pike.initClient', {
      bzId,
      alias,
      extra,
      needContinuousInvoke,
      handle,
      success,
      fail,
    })
  }

  // 启动 Pike 客户端
  startPikeClient(bzId, success = () => {}, fail = () => {}) {
    this._handleNativeAction('pike.startClient', { bzId, success, fail })
  }

  // 停止 Pike 客户端
  stopPikeClient(bzId, success = () => {}, fail = () => {}) {
    this._handleNativeAction('pike.stopClient', { bzId, success, fail })
  }

  // 释放 Pike 客户端
  releasePikeClient(bzId, success = () => {}, fail = () => {}) {
    this._handleNativeAction('pike.releaseClient', { bzId, success, fail })
  }

  // 获取 Pike 隧道状态
  getPikeState(bzId, success = () => {}, fail = () => {}) {
    this._handleNativeAction('pike.getTunnelState', { bzId, success, fail })
  }

  // 处理原生方法调用
  _handleNativeAction(action, params = {}, fallback) {
    if (env.isTitans) {
      // 如果支持原生方法，则调用原生方法
      window.KNB.ready(() => {
        try {
          window.KNB[action](params)
        } catch (error) {
          console.error('KNB action error:', error)
          fallback?.()
        }
      })
    } else if (fallback) {
      // 否则执行 fallback
      fallback()
    }
  }

  // 处理原生订阅
  _handleNativeSubscription(action, handle, success, fail, fallback) {
    this._handleNativeAction(
      'unsubscribe',
      {
        action,
        success: () =>
          this._handleNativeAction('subscribe', {
            action,
            handle,
            success,
            fail,
          }),
      },
      fallback
    )
  }
}

export default KNBBridge
